import React from 'react';
import { UiTextProps, UiText } from '@open-stack/ui';
import styled from 'styled-components';
import clsx from 'clsx';

export enum XTextType {
    DEFAULT = 't_def',
    TITLE = 't_tit',
    TITLE_LARGE = 't_tit_l',
    LABEL = 't_lab',
    PRODUCT_DESCRIPTION = 't_pd',
    CARD_DESCRIPTION = 't_cd',
    NAV_TOP_TITLE = 't_ntt',
    LINK = 't_l',
}

const Wrapper = styled(UiText)`
    &.${XTextType.DEFAULT} {
        font-size: 18px;
    }

    &.${XTextType.TITLE} {
        font-size: 20px;
    }

    &.${XTextType.TITLE_LARGE} {
        font-size: 32px;
    }

    &.${XTextType.LABEL} {
        font-size: 10px;
        letter-spacing: 1px;
        text-transform: uppercase;
        font-weight: bold;
    }

    &.${XTextType.PRODUCT_DESCRIPTION} {
        font-size: 16px;
        color: var(--x-color-text-secondary);
    }

    &.${XTextType.CARD_DESCRIPTION} {
        font-size: 18px;
        color: var(--x-color-text-secondary);
    }

    &.${XTextType.NAV_TOP_TITLE} {
        font-size: 18px;
        color: var(--x-color-text-secondary);
    }

    &.${XTextType.LINK} {
        font-size: 18px;
        color: var(--x-color-primary);
        font-weight: bold;
    }
`;

interface Props extends UiTextProps {
    type?: XTextType;
}

export function XText({ type, ...rest }: Props) {
    type = type ?? XTextType.DEFAULT;
    return <Wrapper {...rest} className={clsx(rest.className, type)} />;
}
